// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardMsisdnPage_wrapper__s4EwG","container-full":"DashboardMsisdnPage_container-full__oRaZX"};